export const divisionCenters = {
  dhaka: [23.8103, 90.4125],
  chattogram: [22.3569, 91.7832],
  khulna: [22.8456, 89.5403],
  rajshahi: [24.3636, 88.6241],
  barisal: [22.701, 90.3535],
  sylhet: [24.8949, 91.8687],
  rangpur: [25.7466, 89.25],
  mymensingh: [24.7471, 90.4203],
};
